export enum PaymentStatuses {
  'succeeded' = 'Success',
  'payment_failed' = 'Failed',
}
